export default "__VITE_ASSET__8d26382e__"